<style scoped lang="scss">
    @import "../styles/var";
    @import "../styles/mixins";

    .middle {
        margin-left: 1%;
        margin-right: 1%;
    }

    .p {
        padding-left: 28px;
    }

    .pic {
        li, img {
            @include w_h(60px);
        }
    }

    .blank {
        height: 10px;
        background-color: $bgColor;
    }
</style>
<template>
    <div class="container">
        <div class="flex">
            <div class="flex0 width24">
                <consult-list></consult-list>
            </div>
            <div class="middle flex0 width40 flex column bg_fff">
                <div class="title flex0 flex color_333 fs14 pl15 pr15 pt10 pb10 bb">
                    <span class="flex0">李俊基</span>
                    <span class="flex0 ml5">男</span>
                    <span class="flex0 ml5">23岁</span>
                    <span class="flex1 ml5">就诊卡号：100098</span>
                    <span class="flex0 color_red">结束分诊</span>
                </div>
                <div>
                    <v-title title="病情描述：" size="15"></v-title>
                    <div class="p pr15 pb15 fs12 color_999">
                        医生医生，我有个问题想咨询你一下，小腹胀痛，不知道看哪个科室。医生医生，我有个问题想咨询你一下，小腹胀痛，不知道看哪个科室。
                    </div>
                    <ul class="pic flex pl15">
                        <li v-for="i in 6" class="flex0 mr10">
                            <img src="../assets/1.png" alt="">
                        </li>
                    </ul>
                    <div class="flex fs14 color_333 pl15 pr15 aic pt10 pb10">
                        <img src="../assets/头像.png" alt="">
                        <span class="flex1 ml5">杜海涛</span>
                        <span>2017/9/7 14:24</span>
                    </div>
                </div>
                <message-box blank="30"></message-box>
                <send-msg-box>
                    <div class="flex1 flex jce aic" slot="btns">
                        <span class="fs14 color_main pointer">加号</span>
                        <span class="fs14 color_main pointer ml5">开处方</span>
                    </div>
                </send-msg-box>
            </div>
            <div class="flex0 width34 bg_fff flex column">
                <div class="title flex0 flex color_333 fs14 pl15 pr15 pt10 pb10 bb">
                    <span class="flex0">患者档案</span>
                </div>
                <consult-pat-info></consult-pat-info>
                <consult-actions></consult-actions>
                <div class="blank"></div>
                <div class="title flex0 flex aic color_333 fs14 pl15 pr15 pt10 pb10 bb">
                    <span class="flex1">手机号</span>
                    <span class="flex0 color_999">13456876534</span>
                    <span class="iconfont fs12 color_999 icon-fanhui-copy"></span>
                </div>
                <div class="title flex0 flex aic color_333 fs14 pl15 pr15 pt10 pb10">
                    <span class="flex1">身份证号</span>
                    <span class="flex0 color_999">379829198403170618</span>
                    <span class="iconfont fs12 color_999 icon-fanhui-copy"></span>
                </div>
                <div class="blank"></div>
                <div class="title flex0 flex aic color_333 fs14 pl15 pr15 pt10 pb10 bb">
                    <span class="flex1">备注名</span>
                    <span class="flex0 color_999">未雨绸缪</span>
                    <span class="iconfont fs12 color_999 icon-fanhui-copy"></span>
                </div>
                <div class="title flex0 flex aic color_333 fs14 pl15 pr15 pt10 pb10 bb">
                    <span class="flex1">分组</span>
                    <span class="flex0 color_999">分组1，分组2</span>
                    <span class="iconfont fs12 color_999 icon-fanhui-copy"></span>
                </div>
                <div class="title flex0 flex aic color_333 fs14 pl15 pr15 pt10 pb10">
                    <span class="flex1">设为VIP</span>
                    <span class="flex0 color_999"><el-switch v-model="isVip"></el-switch></span>
                </div>
                <div class="blank flex1 fs12 flex jcc color_999 pt5">
                    设为VIP后患者可以主动免费向您发送消息
                </div>
            </div>
        </div>
    </div>
</template>

<script>
  import VTitle from "../components/common/v-title";
  import MessageBox from "../components/common/message-box";
  import SendMsgBox from "../components/common/send-msg-box";
  import ConsultList from "../components/consult/list";
  import ConsultPatInfo from "../components/consult/info";
  import ConsultActions from "../components/consult/actions";

  export default {
    name: "Gp",
    data() {
      return {
        list: [],
        curr: {},
        isVip: 1 === 1
      }
    },
    computed: {},
    components: {ConsultActions, ConsultPatInfo, ConsultList, SendMsgBox, MessageBox, VTitle},
    mixins: [],
    created() {
    },
    mounted() {
    },
    watch: {},
    methods: {},
  }
</script>

